// Vendor libraries
import { EventEmitter } from '@angular/core';
// Directives
import { MetricSelectorModalDirective } from '../metric-selector-modal/metric-selector-modal.directive';
// Components
import { MultiMetricByCategoryListComponent } from '../multi-metric-by-category-list/multi-metric-by-category-list.component';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../entitlements/static/entitlements/ts/features/feature-needed/feature-needed.component";
import * as i2 from "../../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i6 from "../multi-metric-by-category-list/multi-metric-by-category-list.component";
/**
 * Multi Select Metric Modal
 *
 * A modal that allows users to select at most one metric.
 * This modal is opened by metric-autocomplete-in-place 'handleButtonClick'
 *
 * Inputs:
 *   maxMetrics: The maximum number of metrics that can be selected. Default null (No limit)
 *
 * Outputs:
 *   selectMetricsHandler: An event emitter that emits the selected metric.
 */
export class MultiMetricSelectorModalComponent extends MetricSelectorModalDirective {
    constructor() {
        super(...arguments);
        this.maxMetrics = null;
        this.submitModalHandler = new EventEmitter();
        this.errorText = '';
    }
    submitModal() {
        const metrics = this.multiMetricByCategoryListComponent.getSelectedMetrics();
        this.submitModalHandler.emit(this.validateFeatureNeeded(metrics));
        this.closeModal();
    }
    selectedItemsCount() {
        if (this.multiMetricByCategoryListComponent) {
            const metrics = this.multiMetricByCategoryListComponent.getSelectedMetrics();
            return metrics.length;
        }
        return 0;
    }
    isSubmissionEnabled() {
        if (this.multiMetricByCategoryListComponent) {
            const metrics = this.multiMetricByCategoryListComponent.getSelectedMetrics();
            return metrics.length > 0;
        }
        return false;
    }
    resetModal() {
        this.multiMetricByCategoryListComponent.reset();
        this.handleMaxLimitError(false);
    }
    submitModalAutocomplete(autocompleteResult) {
        const validResults = this.validateFeatureNeeded([autocompleteResult]);
        if (validResults.length > 0) {
            const metricMenuItemInfo = this.multiMetricByCategoryListComponent.getMetricInfo(autocompleteResult.search_id);
            this.multiMetricByCategoryListComponent.selectMetric({
                feature_needed: autocompleteResult.feature_needed,
                internal_name: autocompleteResult.search_id,
                label: autocompleteResult.name,
            }, metricMenuItemInfo.categoryLabel, metricMenuItemInfo.sectionLabel, metricMenuItemInfo.menuLabel);
            this.multiMetricByCategoryListComponent.scrollToMetric(metricMenuItemInfo);
        }
    }
    handleMaxLimitError(limitReached) {
        this.errorText = limitReached ? 'The maximum metrics limit has been reached' : '';
    }
}
MultiMetricSelectorModalComponent.ɵfac = /*@__PURE__*/ (() => { let ɵMultiMetricSelectorModalComponent_BaseFactory; return function MultiMetricSelectorModalComponent_Factory(__ngFactoryType__) { return (ɵMultiMetricSelectorModalComponent_BaseFactory || (ɵMultiMetricSelectorModalComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MultiMetricSelectorModalComponent)))(__ngFactoryType__ || MultiMetricSelectorModalComponent); }; })();
MultiMetricSelectorModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MultiMetricSelectorModalComponent, selectors: [["ycn-multi-metric-selector-modal"]], viewQuery: function MultiMetricSelectorModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MultiMetricByCategoryListComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiMetricByCategoryListComponent = _t.first);
    } }, inputs: { maxMetrics: "maxMetrics" }, outputs: { submitModalHandler: "submitModalHandler" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 10, consts: [[3, "closeModalHandler", "open"], ["resetModalText", "Reset", 3, "closeModalHandler", "resetModalHandler", "header"], [1, "modal-body"], [1, "modal-section", "form-row"], [3, "submitHandler", "searchType", "defaultOnly"], [3, "maxLimitReachedHandler", "maxMetrics", "categories", "showInfoPopover"], [3, "cancelHandler", "submitHandler", "errorText", "selectedItemCount", "disableSubmission"]], template: function MultiMetricSelectorModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function MultiMetricSelectorModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function MultiMetricSelectorModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); })("resetModalHandler", function MultiMetricSelectorModalComponent_Template_ycn_simple_modal_header_resetModalHandler_1_listener() { return ctx.resetModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "ycn-icon-search-autocomplete", 4);
        i0.ɵɵlistener("submitHandler", function MultiMetricSelectorModalComponent_Template_ycn_icon_search_autocomplete_submitHandler_4_listener($event) { return ctx.submitModalAutocomplete($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(5, "ycn-multi-metric-by-category-list", 5);
        i0.ɵɵlistener("maxLimitReachedHandler", function MultiMetricSelectorModalComponent_Template_ycn_multi_metric_by_category_list_maxLimitReachedHandler_5_listener($event) { return ctx.handleMaxLimitError($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "ycn-simple-modal-footer", 6);
        i0.ɵɵlistener("cancelHandler", function MultiMetricSelectorModalComponent_Template_ycn_simple_modal_footer_cancelHandler_6_listener() { return ctx.closeModal(); })("submitHandler", function MultiMetricSelectorModalComponent_Template_ycn_simple_modal_footer_submitHandler_6_listener() { return ctx.submitModal(); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(7, "ycn-feature-needed");
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.open);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Select Financial Metrics");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("searchType", ctx.searchType)("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance();
        i0.ɵɵproperty("maxMetrics", ctx.maxMetrics)("categories", ctx.categories)("showInfoPopover", ctx.showInfoPopover);
        i0.ɵɵadvance();
        i0.ɵɵproperty("errorText", ctx.errorText)("selectedItemCount", ctx.selectedItemsCount())("disableSubmission", !ctx.isSubmissionEnabled());
    } }, dependencies: [i1.FeatureNeededComponent, i2.IconSearchAutocompleteComponent, i3.ModalBaseComponent, i4.SimpleModalFooterComponent, i5.SimpleModalHeaderComponent, i6.MultiMetricByCategoryListComponent], encapsulation: 2 });
